import React from "react";
import { FileIcon } from "react-file-icon";
import { Typography } from "@material-ui/core";

import { FileDownload } from "../../../../../file-download/components/file-download/file-download-component";
import {
  getFileExtensionFromAssets,
  getFileNameFromAssets,
} from "../../../../../types/file-attachment.functions";

import { AssetItem } from "./file-link.styles";

import { FileLinkProps } from "./file-link.props";

export const FileLink = (props: FileLinkProps) => (
  <FileDownload
    authRequired={props.authRequired}
    disabled={!props.canDownload}
    saveAsFileName={getFileNameFromAssets(props.asset)}
    url={props.asset.url}
    variant="text"
  >
    <AssetItem title={getFileNameFromAssets(props.asset)}>
      <FileIcon extension={getFileExtensionFromAssets(props.asset)} />
      <Typography noWrap>{getFileNameFromAssets(props.asset)}</Typography>
    </AssetItem>
  </FileDownload>
);
